import React from 'react';
import RocketsList from '../components/RocketsList';

const Rockets = () => (
  <div>
    <RocketsList />
  </div>
);

export default Rockets;
